import React from 'react';

import { AspectRatio, Modal } from 'native-base';

import { Text } from '../Text';
import type { IModalContentProps } from './ModalContent.types';
import { LoadingSpinner } from '../LoadingSpinner';

export const ModalContent: React.FunctionComponent<IModalContentProps> = ({
  body,
  footer,
  hideIcon = false,
  image,
  isLoading,
  size,
  subtitle,
  title,
  onPressDismiss,
  ...props
}) => {
  if (isLoading) {
    return (
      <Modal.Content size={size} py={10}>
        <LoadingSpinner size="lg" />
      </Modal.Content>
    );
  }

  return (
    <Modal.Content size={size} {...props}>
      {!hideIcon && <Modal.CloseButton onPress={onPressDismiss} />}
      {image && size === 'sm' && (
        <AspectRatio
          backgroundColor="gray.100"
          ratio={16 / 9}
          width="100%"
          overflow="hidden"
        >
          {image}
        </AspectRatio>
      )}
      <Modal.Header size={size}>
        {title}
        {subtitle && size === 'lg' && (
          <Text color="secondary" fontSize="sm" lineHeight="sm" marginTop="1">
            {subtitle}
          </Text>
        )}
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      {footer && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal.Content>
  );
};
